<template>
  <div class="complete notranslate">
    <p class="mb30" data-status="paid">{{locale.alert_complete_reservation}}</p>
    <div class="btns">
      <router-link :to="{name: 'main', params: {ln: ln}}" class="btn">{{locale.go_main}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Complete',
  props: [
    'ln',
    'locale',
    'isPublic',
    'reservationId'
  ],
  computed: {
    auth () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    isPrivate () {
      const noFrame = (this.auth.frame && this.auth.frame === 'false') || false
      return this.isPublic && noFrame
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.complete {
  padding: 80px 0 200px;
  text-align: center;
  p {
    padding-left: 30px;
    padding-right: 30px;
    font-size: 1.2em;
    &:before {
      content: "";
      display: block;
      height: 96px;
      margin-bottom: 30px;
      background: url('~@/assets/img/warn.png') 50% 50% / contain no-repeat;
    }
    &[data-status="paid"]:before {
      background-image: url('~@/assets/img/complete.png');
    }
  }
}
.btns {
  display: flex;
  max-width: 480px;
  margin: 0 auto;
  padding: 0 7px;
  .btn {
    flex: 1;
    width: calc(50% - 8px);
    margin: 0 8px;
    padding-left: 0;
    padding-right: 0;
    border-radius: 8px;
  }
}
</style>
